import { InventoryCountMonitoringPage } from "@/features/inventory-count/pages/InventoryCountMonitoringPage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/inventory-count-monitoring/")({
	beforeLoad({ context }) {
		if (!context.authAdapter.can({ permissions: ["inventory_count.view"] })) {
			throw redirect({ to: "/403" });
		}
	},
	component: InventoryCountMonitoringPage,
});
